import React, { useCallback, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { useFormik } from 'formik'

import DeepCopyStep from './Steps/DeepCopyStep'
import FormDrawerWrapper from '../../../../features/components/FormDrawerWrapper'
import StartTimeStep from './Steps/StartTimeStep'
import StopTimeStep from './Steps/StopTimeStep'
import StatusStep from './Steps/StatusStep'
import CampaignDuplicationProgressStep from './Steps/CampaignDuplicationProgressStep'
import StepForm from '../../../../features/components/Forms/StepForm'

import { usePurifiedFormik } from '../../../../hooks/formHooks/usePurifiedFormik'
import useManageDrawer from '../../../../hooks/formHooks/useManageDrawer'

import {
  duplicateCampaignErrorSelector,
  duplicateCampaignIsLoadingSelector
} from '../../../../modules/selectors/campaigns'
import { clearDuplicateCampaign } from '../../../../modules/actions/campaigns'
import { clearAsyncSession } from '../../../../modules/actions/app'

import { CAMPAIGN_FACEBOOK_DUPLICATE } from '../../../../constants/forms'
import { DEEP_COPY_OPTION, DEEP_COPY_YES, initialValues, validationSchema } from './fields'

function CampaignFacebookDuplicate() {
  const dispatch = useDispatch()

  const clearDuplicateCampaignHandler = useCallback(() => {
    dispatch(clearDuplicateCampaign())
    dispatch(clearAsyncSession())
  }, [dispatch])

  const { handleFormClose, selectedEditItemId } = useManageDrawer({
    onAfterFormClose: clearDuplicateCampaignHandler,
    formName: CAMPAIGN_FACEBOOK_DUPLICATE
  })

  const onSuccessSubmit = useCallback(() => {
    handleFormClose()
  }, [handleFormClose])

  const formik = useFormik({
    initialValues,
    validationSchema
  })

  const purifiedFormik = usePurifiedFormik(formik)

  const { values } = purifiedFormik

  const isDeepCopy = values[DEEP_COPY_OPTION] === DEEP_COPY_YES

  const steps = useMemo(
    () => [
      {
        component: <DeepCopyStep />,
        show: true
      },
      {
        component: <StartTimeStep />,
        show: isDeepCopy
      },
      {
        component: <StopTimeStep />,
        show: isDeepCopy
      },
      {
        component: <StatusStep selectedEditItemId={selectedEditItemId} />,
        show: true
      },
      {
        component: <CampaignDuplicationProgressStep onSuccessSubmit={onSuccessSubmit} />,
        show: true
      }
    ],
    [selectedEditItemId, onSuccessSubmit, isDeepCopy]
  )

  return (
    <FormDrawerWrapper formName={CAMPAIGN_FACEBOOK_DUPLICATE} showOpenButton={false}>
      <StepForm
        formName={CAMPAIGN_FACEBOOK_DUPLICATE}
        steps={steps}
        formik={purifiedFormik}
        submitOnLastStep={false}
        errorSelector={duplicateCampaignErrorSelector}
        isLoadingSelector={duplicateCampaignIsLoadingSelector}
      />
    </FormDrawerWrapper>
  )
}

export default CampaignFacebookDuplicate
